import {deserialize} from 'libs/cerialize';

export class ExampleAppointmentResponseModel {
	@deserialize
	Id: number;

	@deserialize
	Name: string;
}